import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productionOrderActions } from "../../../../../../actions";
import {
  Divider,
  Button,
  TextField,
  Grid,
  Stack,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import styles from "./../ParameterForm.module.scss";

const ProductionOrder = (props) => {
  const {
    title,
    titleSingle,
    mode,
    paramdata,
    handleSuccessDialog,
    handleErrorAlert,
  } = props;

  const dispatch = useDispatch();
  const paramState = useSelector((state) => state.productionOrders);
  const alertState = useSelector((state) => state.alert);
  const formikRef = React.createRef();

  const debug = false;
  // const [submitting, setSubmitting] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [isTrimToggle, setIsTrimToggle] = useState(false);
  const successMsg = "";

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    chinese_name: Yup.string().required("Chinese Name is required"),
    is_trim: Yup.boolean().nullable(),
    status: Yup.boolean().nullable(),
  });

  const initialValues = {
    name: "",
    chinese_name: "",
    is_trim: false,
    status: true,
  };

  useEffect(() => {
    const prefillData = () => {
      if (mode === "edit" && paramdata) {
        const fields = ["name", "chinese_name"];

        fields.forEach((field) =>
          formikRef.current.setFieldValue(field, paramdata[field], false)
        );
        formikRef.current.setFieldValue(
          "is_trim",
          paramdata?.is_trim === 1 ? true : false,
          false
        );
        setIsTrimToggle(paramdata?.is_trim === 1 ? true : false);
        formikRef.current.setFieldValue(
          "status",
          paramdata?.status === 1 ? true : false,
          false
        );
        setToggle(paramdata?.status === 1 ? true : false);
      }
    };

    prefillData();
  }, []);

  useEffect(() => {
    const handleSuccess = () => {
      if (paramState?.parameter?.data && alertState.type === "success") {
        handleSuccessDialog(successMsg);
      }
    };

    const handleError = () => {
      if (paramState?.error && alertState.type === "error") {
        handleErrorAlert(successMsg);
      }
    };

    handleSuccess();
    handleError();
  }, [paramState, handleSuccessDialog, alertState, handleErrorAlert]);

  const handleSubmit = (values) => {
    if (values && mode === "add") {
      dispatch(
        productionOrderActions.addParameter(
          values.name,
          values.chinese_name,
            values.is_trim,
          values.status,
        )
      );
    }
    if (values && mode === "edit") {
      console.log(values, "values");
      dispatch(
        productionOrderActions.updateParameter(
          paramdata.id,
          values.name,
          values.chinese_name,
          values.is_trim,
          values.status
        )
      );
    }
  };

  const handleToggle = (e) => {
    console.log(e.target.checked);
    setToggle(e.target.checked);
  };

  const handleIsTrimToggle = (e) => {
    setIsTrimToggle(e.target.checked);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        innerRef={formikRef}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm();
        }}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          isValid,
          setFieldValue,
        }) => (
          <Form noValidate autoComplete="off">
            <Grid container spacing={{ xs: 2, sm: 2 }} sx={{ pt: 0, pb: 0 }}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="name"
                  name="name"
                  label="Name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  variant="standard"
                  className={styles.textField}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="chinese_name"
                  name="chinese_name"
                  label="Chinese Name"
                  value={values.chinese_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.chinese_name && Boolean(errors.chinese_name)}
                  helperText={touched.chinese_name && errors.chinese_name}
                  variant="standard"
                  className={styles.textField}
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isTrimToggle}
                        onChange={(e) => {
                          handleIsTrimToggle(e);
                          setFieldValue("is_trim", e.target.checked);
                        }}
                        id="is_trim"
                        name="is_trim"
                      />
                    }
                    label="Is trim"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={toggle}
                        onChange={(e) => {
                          handleToggle(e);
                          setFieldValue("status", e.target.checked);
                        }}
                        id="status"
                        name="status"
                      />
                    }
                    label="Active"
                  />
                </FormGroup>
              </Grid>

              <Grid item xs={12}>
                <Stack
                  direction="column-reverse"
                  justifyContent="space-between"
                  align-items="center"
                  sx={{
                    flexDirection: {
                      sm: "row",
                    },
                    mt: 2,
                  }}
                >
                  <Link to="../" style={{ display: "block" }}>
                    <Button
                      size="medium"
                      startIcon={<ArrowBackIcon size="small" />}
                      sx={{ textTransform: "none" }}
                    >
                      Back to {title}
                    </Button>
                  </Link>

                  <span style={{ flex: 1 }}>&nbsp;</span>

                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    fullWidth
                    type="submit"
                    size="large"
                    loading={paramState?.loading}
                    // loadingPosition="end"
                    sx={{
                      width: {
                        xs: "100%",
                        md: "auto",
                      },
                    }}
                  >
                    {`Save ${titleSingle}`}
                  </LoadingButton>
                </Stack>
              </Grid>
            </Grid>

            {debug && (
              <>
                <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                <pre style={{ textAlign: "left" }}>
                  <strong>Values</strong>
                  <br />
                  {JSON.stringify(values, null, 2)}
                </pre>
                <pre style={{ textAlign: "left" }}>
                  <strong>Errors</strong>
                  <br />
                  {JSON.stringify(errors, null, 2)}
                </pre>
              </>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ProductionOrder;
